import { render, staticRenderFns } from "./live-module.vue?vue&type=template&id=57d2af42&scoped=true&"
import script from "./live-module.vue?vue&type=script&lang=js&"
export * from "./live-module.vue?vue&type=script&lang=js&"
import style0 from "./live-module.vue?vue&type=style&index=0&id=57d2af42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d2af42",
  null
  
)

export default component.exports